export default __webpack_public_path__ + "static/media/external-link-white.98de3990.svg";